import Ember from 'ember';
import { restartableTask } from 'ember-concurrency';
import Infinity from 'ember-infinity/services/infinity';
import JsonApiInfinityModel from 'volta/models/jsonapi-infinity-model';
import SkuModel, { ResourceName } from 'volta/models/sku';
import { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';
import { defaultErrorHandler } from 'volta/utils/error-utils';
import { eqFilter } from 'volta/utils/filters-utils';

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type SkusCollectionDefinitionBuilder from 'volta/services/collection-builder-skus';
interface IArgs {
  queryParams: TQueryParams;
  excludedIds?: string[];
  onSelectionChange?: (items: SkuModel[]) => void;
}
export default class SkuList extends Component<IArgs> {
  @service infinity!: Infinity;
  @service collectionBuilderSkus!: SkusCollectionDefinitionBuilder;

  @tracked queryParamsValues: TQueryParams = this.args.queryParams ?? {};
  @tracked selectedItems: SkuModel[] = [];

  resourceName = ResourceName;

  constructor(owner: any, args: IArgs) {
    super(owner, args);
    if (isEmpty(this.queryParamsValues.isActive)) {
      this.queryParamsValues.isActive = eqFilter(true);
    }
  }

  get filterDefinitions() {
    return this.collectionBuilderSkus.buildFilters(this.queryParamsValues);
  }

  get selectedSkuIds() {
    return this.selectedItems.mapBy('id');
  }

  // Actions
  // ~~~~~

  @action
  handleSelectionChange(items: SkuModel[]) {
    this.selectedItems = items;
    this.args.onSelectionChange?.(this.selectedItems);
  }

  @action
  onParamsChange(params: TQueryParams) {
    const queryParams = params;
    if (!queryParams.isActive) {
      queryParams.isActive = eqFilter(true);
    }
    this.queryParamsValues = queryParams;
  }

  // Tasks
  // ~~~~~~

  queryTask = restartableTask(async (apiQuery: IJsonApiQuery) => {
    try {
      const response: Ember.Array<SkuModel> = await this.infinity.model(
        this.resourceName.singular,
        apiQuery,
        JsonApiInfinityModel
      );
      return response;
    } catch (error) {
      return defaultErrorHandler(error);
    }
  });
}
